
<div class="card-sales">
  <page-header :title="showPurgatorySales ? 'Purgatory Sales' : 'All Sales'" small>
    <template #actions>
      <div class="actions">
        <icon-button
          icon="view_list"
          :class="{ success: salesViewType === 'list' }"
          tooltip="Full details view"
          @click="salesViewType = 'list'"
        />

        <icon-button
          icon="list"
          :class="{ success: salesViewType === 'table' }"
          tooltip="Table view"
          @click="salesViewType = 'table'"
        />

        <template v-if="isLadderCard">
          <icon-button
            v-if="isStaffView"
            tooltip="Initial scrape"
            icon="move_to_inbox"
            :loading="scraping"
            @click="startInitialScrape(false)"
          />

          <icon-button
            icon="inventory"
            :tooltip="showPurgatorySales ? 'Hide Purgatory Sales' : 'Show Purgatory Sales'"
            @click="showPurgatorySales = !showPurgatorySales"
          />
        </template>

        <icon-button icon="close" @click="close" />
      </div>
    </template>
  </page-header>

  <div v-show="!showPurgatorySales" class="filters">
    <div class="sorting">
      <select-input
        id="sort"
        v-model="sort"
        label="Sort"
        :options="sortOptions"
      />
    </div>

    <div v-if="!isPrivateCollectionCard" class="sorting">
      <date-input
        id="maxdate"
        v-model="dateFilter"
        label="Max Date"
        has-clear
        :min="minDateFilter"
      />
    </div>
  </div>

  <empty-state
    v-if="showEmptyState && (showPurgatorySales || (!isPrivateCollectionCard && !isStaffView))"
    icon="point_of_sale"
    :title="showPurgatorySales ? 'There are no sales for this card in purgatory.' : 'There are no sales for this card yet'"
  />

  <empty-state
    v-else-if="showEmptyState && isStaffView"
    icon="not_started"
    title="Add sales for this card to estimate the value automatically"
    :description="isStaffView ? 'After you have the image selected run this to get the pop and sales scraped' : ''"
  >
    <btn
      loading-text="Scraping"
      :loading="scraping"
      @click="handleAdminInit"
    >
      {{ adminStartButtonText }}
    </btn>
  </empty-state>

  <template v-else-if="loaded">
    <div v-if="salesViewType === 'list'" class="list">
      <card-sales-row
        v-for="sale in computedSales"
        :key="sale.id"
        :sale="sale"
        :purgatory="showPurgatorySales"
        :is-ladder-card="isLadderCard"
        @deleteSale="deleteSale"
        @moveToSales="moveToSales"
        @moveToPurgatory="moveToPurgatory"
        @addToHeadlines="addToHeadlines"
        @viewSalesHistory="viewSalesHistory"
        @viewTerapeak="viewTerapeak"
      />
    </div>

    <table v-else class="table-list">
      <thead>
        <th>Date</th>
        <th right>
          Price
        </th>
        <th right>
          Type
        </th>
        <th right>
          Platform
        </th>
        <th class="action" />
      </thead>

      <tbody>
        <card-sales-table-row
          v-for="sale in computedSales"
          :key="sale.id"
          :sale="sale"
          :purgatory="showPurgatorySales"
          :is-ladder-card="isLadderCard"
          @deleteSale="deleteSale"
        />
      </tbody>
    </table>

    <infinite-scroll
      scroll-parent-id="side-panel"
      :loading="loading"
      :has-more-data="hasMoreData"
      @load="loadSales(false)"
    />
  </template>

  <spinner v-else />

  <scroll-top is-side-panel />
</div>
